
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"fill":"#888","fill-rule":"evenodd","d":"M16.932 12a5 5 0 11-10 0 5 5 0 0110 0zm-1.5 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#888","fill-rule":"evenodd","d":"M20.794 11.651a.916.916 0 010 .698C19.22 16.173 15.684 19 11.932 19c-3.753 0-7.287-2.827-8.863-6.651a.916.916 0 010-.698C4.645 7.827 8.18 5 11.932 5s7.287 2.827 8.862 6.651zM11.932 6.5c2.935 0 5.937 2.214 7.38 5.5-1.444 3.286-4.445 5.5-7.38 5.5-2.936 0-5.937-2.214-7.381-5.5 1.444-3.286 4.445-5.5 7.38-5.5z","clip-rule":"evenodd"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      